(() => {
  let analyticsAllowed;
  let reloadPending = false;

  function clearAnalyticsCookies() {
    const names = document.cookie.split(';').map(cookie => cookie.split('=')[0].trim())
      .filter(name => /^(?:_ga(?:_.+)?|_gid|_gat(?:_.+)?|AMP_TOKEN)$/.test(name));
    const domains = [''];
    const parts = location.hostname.split('.');
    while (parts.length > 1) {
      domains.push(parts.join('.'));
      parts.shift();
    }
    const paths = new Set(['/']);
    let path = '';
    for (const segment of location.pathname.split('/').filter(Boolean)) {
      path += '/' + segment;
      paths.add(path);
      paths.add(path + '/');
    }
    for (const name of names) {
      for (const domain of domains) {
        for (const cookiePath of paths) {
          document.cookie = name + '=; Max-Age=0; Expires=Thu, 01 Jan 1970 00:00:00 GMT; Path='
            + cookiePath + (domain ? '; Domain=' + domain : '');
        }
      }
    }
    return names.length > 0;
  }

  function sync(allowed, changed = false) {
    if (typeof allowed !== 'boolean') return;
    const previous = analyticsAllowed;
    analyticsAllowed = allowed;
    if (allowed) return;
    const hadAnalyticsCookies = clearAnalyticsCookies();
    if (!reloadPending && changed && (previous === true || (previous === undefined && hadAnalyticsCookies))) {
      reloadPending = true;
      location.reload();
    }
  }

  function initialize() {
    const privacy = window.Shopify?.customerPrivacy;
    if (privacy) sync(privacy.analyticsProcessingAllowed());
    else window.Shopify?.loadFeatures?.([{name: 'consent-tracking-api', version: '0.1'}], error => {
      if (!error) sync(window.Shopify?.customerPrivacy?.analyticsProcessingAllowed());
    });
  }

  document.addEventListener('visitorConsentCollected', event => sync(event.detail?.analyticsAllowed, true), true);
  window.addEventListener('pageshow', event => {
    if (event.persisted) sync(window.Shopify?.customerPrivacy?.analyticsProcessingAllowed(), true);
  });
  initialize();
})();
